import app from 'Cloud/Application/app';
import { WopiEditAPICall } from 'reactApp/api/wopi/WopiEditAPICall';
import { WopiEmbeddedViewAPICall, WopiViewAPICall } from 'reactApp/api/wopi/WopiViewAPICall';

enum EProviderId {
    'r7' = 'r7',
    'office' = 'ms',
    'myoffice' = 'co',
    'myofficeattaches' = 'co',
}

const getData = (itemPath) => {
    if (app.isStock()) {
        return { stock: itemPath };
    }

    if (app.isPublic()) {
        return { public: `/${itemPath}` };
    }

    return { home: itemPath };
};

export const callWopiViewAPICall = (itemPath, editor) =>
    new WopiViewAPICall().makeRequest({ ...getData(itemPath), provider: EProviderId[editor.toLowerCase()] });

export const callWopiEditAPICall = (itemPath, editor) =>
    new WopiEditAPICall().makeRequest({ ...getData(itemPath), provider: EProviderId[editor.toLowerCase()] });

export const callWopiEmbeddedViewAPICall = (params: Record<'email' | 'name' | 'url', string>, editor: keyof typeof EProviderId) =>
    new WopiEmbeddedViewAPICall().makeRequest({ ...params, provider: EProviderId[editor.toLowerCase()] });
